import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../styles/footer.css';

const Footer = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  // Fonction pour préfixer les URL avec la langue actuelle si nécessaire
  const getLocalizedPath = (path) => {
    // Si nous sommes sur une page française, ajouter le préfixe /fr aux chemins
    return currentLang === 'fr' ? `/fr${path}` : path;
  };

  return (
    <footer className="footer">
      <div className="footer__container">
        <Link to={getLocalizedPath('/')} className="footer__logo">
          AiVatar
        </Link>
        
        <div className="footer__links">
          <Link to={getLocalizedPath('/linkedin-headshot')} className="footer__link">
            LinkedIn Headshot
          </Link>
          <Link to={getLocalizedPath('/terms-of-service')} className="footer__link">
            Terms of Service
          </Link>
          <Link to={getLocalizedPath('/privacy-policy')} className="footer__link">
            Privacy Policy
          </Link>
          <a href="mailto:contact@muware.xyz" className="footer__contact">
            contact@muware.xyz
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 